<template>
  <div :style="themeVars">
    <v-card elevation="2" class="card">
      <v-card-text>
        <v-row dense class="flex-column">
          <v-row dense class="align-center">
            <v-col cols="auto">
              <v-avatar color="primary-500" size="56" class="mt-1">
                <v-img v-if="item.avatar" :src="item.avatar" rounded contain />
                <span v-else class="white--text font-weight-bold">
                  {{ item.name ? item.name.slice(0, 2).toUpperCase() : "PE" }}
                </span>
              </v-avatar>
            </v-col>
            <v-col>
              <div class="card__eyebrow">Professor com horário compatível</div>
              <span class="text-h4 mt-1 gradientTitle">{{ item.name }}</span>
            </v-col>
          </v-row>

          <span class="text-h6 mt-2" v-if="item.hasCertificate"
            >Certificações:

            <span class="text-h6 gradientTitle">
              {{ item.certificates.join(",") }}
            </span>
          </span>

          <span class="text-h6"
            >Modalidade:<span class="text-h6">
              <span class="text-h6 gradientTitle">
                {{
                  item.plans.length > 0
                    ? displayFormat(item.plans[0].format)
                    : "A combinar"
                }}</span
              ></span
            ></span
          >
          <span class="text-h6"
            >Frequência:
            <span class="text-h6 gradientTitle"
              >{{
                item.plans.length > 0
                  ? displayFrequency(item.plans[0].frequency)
                  : "A combinar"
              }}
            </span></span
          >
          <span class="text-h6"
            >Dia(s) da semana:
            <span class="text-h6 gradientTitle">
              {{ displayWeekDay }}</span
            ></span
          >
          <span class="text-h6"
            >Horário:
            <span class="text-h6 gradientTitle">
              A partir das {{ firstAvailableFrom }}h</span
            ></span
          >

          <div class="mt-4">
            <div class="card__eyebrow mb-2">Horários disponíveis</div>
            <div class="d-flex flex-wrap">
              <v-chip
                v-for="(hour, index) in previewAvailability"
                :key="`${hour.weekDay}-${hour.from}-${index}`"
                small
                outlined
                color="primary-500"
                class="mr-2 mb-2"
              >
                {{ displayWeekDayLabel(hour.weekDay) }} - {{ hour.from }} às
                {{ hour.to }}
              </v-chip>
            </div>
          </div>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-4 pb-4"
        ><span
          class="text-center success-600"
          style="background-clip: text; -webkit-text-fill-color: transparent"
          >R$:
          {{
            item.plans.length > 0
              ? formatPrice(item.plans[0].finalValue ?? item.plans[0].value)
              : "A combinar"
          }}</span
        >
        <v-spacer></v-spacer>
        <v-btn
          rounded
          color="primary-500"
          class="white--text"
          @click="matchUs(item)"
        >
          Solicitar horários
        </v-btn>
      </v-card-actions>
    </v-card>
    <confirm-dialog
      ref="confirmDialog"
      :title="dialogTitle"
      :text="dialogText"
      :item="selected"
      :limit="limit"
      :content="dialogContent"
      @confirmed="requestJoin"
      @cancel="cancel"
    />
  </div>
</template>

<script>
import Colors from "@/styles/app.module.scss";

export default {
  name: "MatchedPartnerCard",
  props: {
    item: {
      type: Object,
    },
    weekDay: {
      type: Number,
    },
    start: {
      type: String,
    },
    limit: {
      type: Number,
    },
  },
  computed: {
    themeVars() {
      return {
        "--customer-primary": Colors["primary-500"],
        "--customer-primary-strong": Colors["primary-600"],
      };
    },
    previewAvailability() {
      return Array.isArray(this.item.available)
        ? this.item.available.slice(0, 4)
        : [];
    },
    firstAvailableFrom() {
      return Array.isArray(this.item.available) && this.item.available.length
        ? this.item.available[0].from
        : "--:--";
    },
    displayWeekDay() {
      const days = new Set((this.item.available || []).map((i) => i.weekDay));
      const nomes = this.weekDaysItems
        .filter((dia) => days.has(String(dia.value)))
        .map((dia) => dia.text);

      return nomes.join(", ");
    },
  },
  data() {
    return {
      dialogTitle: "",
      dialogText: "",
      dialogContent: null,
      selected: null,
      weekDaysItems: [
        {
          text: "Domingo",
          value: 0,
        },
        {
          text: "Segunda-feira",
          value: 1,
        },
        {
          text: "Terça-feira",
          value: 2,
        },
        {
          text: "Quarta-feira",
          value: 3,
        },
        {
          text: "Quinta-feira",
          value: 4,
        },
        {
          text: "Sexta-feira",
          value: 5,
        },
        {
          text: "Sábado",
          value: 6,
        },
      ],
    };
  },
  methods: {
    matchUs(item) {
      this.selected = item;
      this.dialogTitle = `Enviar solicitação ao professor: ${item.name}`;
      this.dialogContent = item.available;
      this.dialogText = `Ao enviar a solicitação, o professor será notificado, após a confirmação sua entrada na turma na turma será automática.`;
      this.$refs.confirmDialog.open();
    },
    displayWeekDayLabel(day) {
      return (
        this.weekDaysItems.find((item) => +item.value === +day)?.text || "-"
      );
    },
    displayFormat(format) {
      switch (format) {
        case 1:
          return "Individual";
        case 2:
          return "Dupla";
        case 3:
          return "Trio";
        case 4:
          return "Quarteto";
      }
    },
    formatPrice(value) {
      return new Intl.NumberFormat("pt-BR", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(parseFloat(value).toFixed(2));
    },
    displayFrequency(frequency) {
      return frequency === 2 ? "2x por semana" : "1x por semana";
    },

    requestJoin(item) {
      this.$emit("requestJoin", item);
    },
    cancel() {
      this.dialogTitle = "";
      this.dialogText = "";
      this.selected = null;
    },
  },
};
</script>

<style lang="css" scoped>
.gradientTitle {
  background: linear-gradient(
    to right,
    var(--customer-primary),
    var(--customer-primary-strong)
  );

  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  animation: moveGradient 3s linear infinite;
}

.glowingText {
  animation: glowText 0.8 ease-in-out infinite alternate;
}

@keyframes moveGradient {
  0% {
    background-position: 50% 0;
  }
  50% {
    background-position: 0 0;
  }
  100% {
    background-position: 100% 0;
  }
}

.card {
  width: 100%;
  min-height: 490px;
  border-radius: 30px 15px 30px 15px;
  background-color: transparent;
  display: flex;
  flex-direction: column;
}

.card__eyebrow {
  font-size: 0.78rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--customer-primary);
  font-weight: 700;
}
.text-h4,
.text-h6 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* limite de linhas */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal; /* permite quebrar linha */
  word-break: break-word; /* evita overflow */
}

.limit-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
